<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="463"> </caass-schoolselector>
						</div>
					</div>

					<!--ExpireDayCount-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Expire In</label>
						<div class="col-sm-4 col-lg-3">
							<div class="InfoGrid2Col">
								<input
									[disabled]="IsLoading() == true"
									class="form-control"
									type="number"
									[(ngModel)]="ExpireDayCount"
									[ngModelOptions]="{ standalone: true }"
									step="1"
									min="0"
									(ngModelChange)="onExpireDayCountChange($event)"
								/>
								<label>days</label>
							</div>
						</div>
					</div>

					<!--ExpireDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Expires On</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar
								[disabled]="IsLoading() == true"
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="ExpireDate"
								[ngModelOptions]="{ standalone: true }"
								name="ExpireDate"
								(ngModelChange)="onExpireDateChange($event)"
							></p-calendar>
						</div>
					</div>

					<!--GradeLevelID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SelectedGradeLevel" [(ngModel)]="SelectedGradeLevel">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstGradeLevel" [ngValue]="o">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--AcademyID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AcademyID" [(ngModel)]="SelectedAcademy">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstAcademy" [ngValue]="o">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--HomeroomID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SelectedHomeroom" [(ngModel)]="SelectedHomeroom">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstHomeroom" [ngValue]="o">
									{{ o.HomeRoom }}
								</option>
							</select>
						</div>
					</div>

					<!--GroupID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SelectedGroup" [(ngModel)]="SelectedGroup">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstGroup" [ngValue]="o">
									{{ o.GroupName }}
								</option>
							</select>
						</div>
					</div>

					<!--ActiveOptionID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Active</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ActiveID" [(ngModel)]="ActiveID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--AlreadyPrintedID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Already Printed</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AlreadyPrintedID" [(ngModel)]="AlreadyPrintedID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstAlreadyPrintedOption" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortByID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortBy" [(ngModel)]="SortBy">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstSortBy" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortDirectionID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort Direction</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortDirection" [(ngModel)]="SortDirection">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstSortDirection" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<!-- <div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="SelectedImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstImageLogo" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div> -->

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ReportOutputTypeID" [(ngModel)]="ReportOutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstReportOutputType" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="Processing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!Processing" class="btn btn-primary" type="button" (click)="onPrint()">Print</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
